import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RolesService } from '@app/services/roles.service';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import * as moment from 'moment';
import { InfosService } from '../../services/infos.service';
import { AuthenticationService } from './../../_services/authentication.service';


@Component({
  selector: 'app-compta-dashboard',
  templateUrl: './compta-dashboard.component.html',
  styleUrls: ['./compta-dashboard.component.scss'],
})
export class ComptaDashboardComponent implements OnInit {

  date;

  loading = true;

  mobile;
  showEncours = true;

  realtimeDate;

  user;
  notifications;
  infosRead = [];
  infosUnread = [];



  showCm = false;

  constructor(
    public sRoles: RolesService,
    private AuthenticationService: AuthenticationService,
    private sInfos: InfosService,
     private router: Router
  ) {
    if (window.screen.width <= 600) {
      this.mobile = true;
    }

    this.AuthenticationService.user.subscribe((x) => (this.user = x));
    this.date = Date.now();
  }

  ngOnInit(): void {
    this.getTime();
    setInterval(() => {
      this.getTime();
    }, 1100);

    this.showNotifications();

  }

  getTime() {
      this.realtimeDate = moment().locale('fr').format('HH:mm');
  }

  showNotifications() {
  return new Promise((resolve) => {
    this.sInfos.getInfoByAdvId(this.sRoles.user.id).subscribe(
      (res) => {
        this.notifications = res;
        this.loading = false;
        this.notifications.forEach((element) => {
          if (element.vu) {
            this.infosRead.push(element);
          } else {
            this.infosUnread.push(element);
          }
        });
        resolve(res);
      },
      (error) => {
        console.log(error);
      }
    );
  });
}

  deleteInfo(id) {
  const deleteInfo = this.infosUnread.filter((item) => item._id !== id);
  this.sInfos.delete(id).subscribe((response) => {
    this.infosUnread = [];
    this.infosRead = [];
    this.infosUnread = deleteInfo;
  });
  }

  goToCase(id, info, infoId) {
  this.saveChange(info, infoId);
  window.location.href = '/compta-case-detail/' + id;
}

  saveChange(info, infoId) {
  info.vu = !info.vu;
  this.sInfos.editInfo(info, infoId).then((res) => {
    if (res['error']) {
      return res.error;
    }
    this.infosUnread = [];
    this.infosRead = [];
    this.showNotifications();
  });
}


}
